import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async (account: string, menu: string) => {
  const snapshot = await getDocs(collection(db, `menus/${account}/menu/${menu}/categories`));
  const categories = snapshot.docs.map((doc) => ({ id: doc.id, name: '', description: '', order: 0, active: false, products: [], ...doc.data() }));
  return categories.filter(it => it.active === true).sort((oldRelease: any, newRelease: any) => {
    const compareOrder = `${oldRelease.order}`.localeCompare(`${newRelease.order}`);
    const compareName = oldRelease.name.localeCompare(newRelease.name);
    return compareOrder || compareName;
  });
};

const funcs = {
  getAll,
};

export default funcs;
